import React, { useLayoutEffect } from 'react'
import { Absolute } from 'mds-web-ui'
import { useMeasure } from 'react-use'

const ScheduleDayHeader = ({ setHeight, ...props }) => {
  const [ref, { height }] = useMeasure()

  useLayoutEffect(() => {
    if (height) setHeight(Math.ceil(height))
  }, [setHeight, height])

  return <Absolute top={0} ref={ref} {...props} />
}

export default ScheduleDayHeader
